import angular from 'angular';

const windowUnloadHandler = event => {};

angular.module('cloudX').directive('confirmOnExit', [
  '$translate',
  '$transitions',
  '$window',
  'dialogsSvc',
  '$q',

  function($translate, $transitions, $window, dialogsSvc, $q) {
    return {
      restrict: 'A',
      require: 'form',
      link: function($scope, elem, attrs, form) {
        const unloadEventHandler = function(event) {
          if (form.$dirty) {
            const msg = $translate.instant('The form is dirty, do you want to stay on the page?');
            event.preventDefault();
            e.returnValue = msg;
            return msg;
          }
        };

        $window.addEventListener('beforeunload', unloadEventHandler);

        const showSaveButton = attrs.confirmOnExit && attrs.confirmOnExit.indexOf('()') > 0;
        const destroyer = $transitions.onStart({}, function(transition) {
          if (form.$dirty) {
            const preventStateChange = () => {
              transition.abort();
              return false;
            };

            return dialogsSvc
              .confirmChanges('msgConfirmLeavePage', 'msgConfirmLeavePageMessage', showSaveButton)
              .then(
                function(result) {
                  if (result === 1) {
                    return undefined; //Discard changes
                  } else if (result === 2) {
                    //Save changes
                    //Todo call save function and handle promise
                    if (showSaveButton) {
                      return $q.when($scope.$eval(attrs.confirmOnExit)).then(
                        function(result) {
                          form.$setSubmitted();
                          return undefined;
                        },
                        function() {
                          return preventStateChange(); //Error when saving? stay on page
                        },
                      );
                    }
                    console.warn("Can't save changes without save function");

                    return undefined; //Discard changes
                  } else {
                    return preventStateChange(); //Cancelled, prevent state change
                  }
                },
                function(error) {
                  return preventStateChange(); //Prevent state change
                },
              );
          }
        });

        $scope.$on('$destroy', function() {
          destroyer();
          window.removeEventListener('beforeunload', unloadEventHandler);
        });
      },
    };
  },
]);
